import { useContext } from 'react';
import { ErrorSummaryContext } from './ErrorSummaryContext';
import { ErrorSummaryContextType } from './types';

export function useErrorSummaryContext() {
  return useContext<ErrorSummaryContextType | null>(ErrorSummaryContext) as ErrorSummaryContextType;
}
